import * as React from 'react';
import classNames from 'classnames';
import './SubscriptionAdd.scss';
import { Grid } from '@material-ui/core';

import * as AddIcon from '../../../../assets/image/add.png';
import * as DiscardIcon from '../../../../assets/image/discard.png';
import * as SubmitIcon from '../../../../assets/image/submitForm.png';

import * as Const from '../../constants';

import pickPackageByProduct from '../../utils/pickPackageByProduct';
import SubDateRange from './SubDateRange';
import SubDropdown from './SubDropdown';
import SubInput from './SubInput';
import SubTooltip from '../Tooltip/SubTooltip';
import ToasterWrapper from '../ToasterWrapper/ToasterWrapper';

import { Option } from 'react-dropdown';

import AvailablePackage from '../../interfaces/AvailablePackage';
import Message from '../../interfaces/Message';
import { SubscriptionPeriod } from '../../../../constants';
import DialogContentText from '@material-ui/core/DialogContentText/DialogContentText';

interface Props {
  onClose?: () => void;
  open?: boolean;
  handleChangeProduct: (arg: Option) => void;
  handleChangeFieldsArea: (e: React.FormEvent<HTMLInputElement>) => void;
  handleChangePackage: (arg: Option) => void;
  handleChangeTypePayment: (arg: Option) => void;
  handleChangePlanePrice: (e: React.FormEvent<HTMLInputElement>) => void;
  handleChangeDateFrom: any;
  handleChangeDateTo: (date: Date) => void;
  handleSubmit: () => void;
  product: string;
  package_: string;
  dateTo: Date;
  dateFrom: Date;
  subscriptionPeriod: SubscriptionPeriod;
  setSubscriptionPeriod: (type: SubscriptionPeriod) => void;
  shouldCreatePayment: boolean;
  setShouldCreatePayment: (value: boolean) => void;
  dateError: string;
  typePayment: string;
  planePrice: string | number;
  clearForm: () => void;
  fetchSubscriptionDataForm?: () => void;
  availableProduct: string[];
  availablePackage: AvailablePackage[];
  sendingFormError: string;
  formRender: string[];
  isFormAreaDisabled?: boolean;
  isFormReady: boolean;
  isFieldsAreaDisabled: boolean;
  fieldsArea: number;
  messages: Message[];
  removeMessage: (id: string) => void;
  isSendingForm: boolean;
}

function SubscriptionAdd (props: Props) {

  const [isFormVisible, setIsFormVisible] = React.useState(false);
  const setIsFormSent = React.useState(false)[1];

  const toggleForm = () => {
    setIsFormVisible(!isFormVisible);
  };

  const toggleFormSent = (isFormSentValue = false) => {
    setIsFormSent(isFormSentValue);
  };

  const handleSubmit = () => {
    toggleForm();
    props.handleSubmit();
    toggleFormSent(true);
    setTimeout(toggleFormSent, 5000);
  };

  const handleDiscard = () => {
    toggleForm();
    props.clearForm();
  };

  const {
    formRender,
    dateError,
    dateFrom,
    dateTo,
    product,
    subscriptionPeriod,
    shouldCreatePayment,
    handleChangeProduct,
    isFieldsAreaDisabled,
    fieldsArea,
    handleChangeFieldsArea,
    package_,
    handleChangePackage,
    typePayment,
    handleChangeTypePayment,
    planePrice,
    handleChangePlanePrice,
    isFormReady,
    handleChangeDateFrom,
    handleChangeDateTo,
    messages,
    removeMessage,
    setSubscriptionPeriod,
    setShouldCreatePayment,
  } = props;

  const formClassNames = classNames('sub-add-form-wrapper', {
    'display-none': !isFormVisible,
  });

  const addBtnClassNames = classNames({
    'display-none': isFormVisible,
  });

  const submitBtnClassNames = classNames('sub-add-form-btn-submit', {
    'sub-exist-form-image-disabled': !isFormReady,
  });

  return (
    <React.Fragment>

      {messages.map((message, step) => (
        <ToasterWrapper
          removeMessage={removeMessage}
          stepPx={step * 70 + 25}
          key={message.id}
          message={message} />
      ))}

      <h3 className='new-form-title'>
        {'New Subscription:'}
      </h3>

      <div className={addBtnClassNames}>

        <button
          onClick={toggleForm}
          className='sub-add-form-btn'>
          <div>
            <img
              src={AddIcon}
              alt='' />
            {'ADD'}
          </div>
        </button>
      </div>

      <div className={formClassNames}>
        {formRender.includes(Const.PRODUCT)
          ? (
            <SubDropdown
              title='Product:'
              placeholder='product'
              value={product}
              options={props.availableProduct}
              onChange={handleChangeProduct}
            />) : null}

        {formRender.includes(Const.PACKAGE)
          ? (
            <SubDropdown
              disabled={!product}
              title='Package:'
              placeholder='package'
              value={package_}
              options={pickPackageByProduct(product, props.availablePackage)}
              onChange={handleChangePackage}
            />) : null}

        {formRender.includes(Const.FIELDS_AREA)
          ? (
            <SubInput
              disabled={isFieldsAreaDisabled}
              title='Fields Area'
              error={isNaN(+fieldsArea)}
              errorMessage={Const.INVALID_NUMBER_INPUT}
              placeholder='area'
              onChange={handleChangeFieldsArea}
              value={fieldsArea}
            />) : null}

        {formRender.includes(Const.TYPE_PAYMENT)
          ? (
            <SubDropdown
              disabled={!package_}
              title='Payment Type:'
              onChange={handleChangeTypePayment}
              value={typePayment}
              options={Const.PAYMENT_TYPES}
            />) : null}

        {formRender.includes(Const.PLANE_PRICE) && typePayment !== Const.NGO
          ? (
            <SubInput
              disabled={!package_}
              title='Price ($)'
              error={isNaN(+planePrice)}
              errorMessage={Const.INVALID_NUMBER_INPUT}
              placeholder='price'
              onChange={handleChangePlanePrice}
              value={planePrice}
            />) : null}

        {formRender.includes(Const.DATE_TO)
          ? (
            <SubDateRange
              dateError={dateError}
              changeDateFrom={handleChangeDateFrom}
              changeDateTo={handleChangeDateTo}
              dateFrom={dateFrom}
              dateTo={dateTo}
            />) : null}
        {/* product === Const.LAND_VIEWER}*/}
        { (formRender.includes(Const.TYPE_PAYMENT)) ? (
          <div className='form-section'>
            <div className='subscription-add-form-group'>
              <DialogContentText>{'Subscription period:'}</DialogContentText>
              <div className='radio-group'>
                <label>
                  <input
                    type='radio'
                    value={SubscriptionPeriod.ANNUAL}
                    checked={subscriptionPeriod === SubscriptionPeriod.ANNUAL}
                    onChange={() => setSubscriptionPeriod(SubscriptionPeriod.ANNUAL)}
                  />
                  <span className='subscription-add-control-label'>{' Annual '}</span>
                </label>

                <label>
                  <input
                    type='radio'
                    value={SubscriptionPeriod.MONTHLY}
                    checked={subscriptionPeriod === SubscriptionPeriod.MONTHLY}
                    onChange={() => setSubscriptionPeriod(SubscriptionPeriod.MONTHLY)}
                  />
                  <span className='subscription-add-control-label'>{' Monthly '}</span>
                </label>
              </div>
            </div>

            <div className='subscription-add-form-group'>
              <label>
                <input
                  type='checkbox'
                  checked={shouldCreatePayment}
                  onChange={() => setShouldCreatePayment(!shouldCreatePayment)}
                />
                <span className='subscription-add-control-label'>{' Create payment '}</span>
              </label>
            </div>
          </div>
        ) : null}
        {!isFormReady
          ? (
            <p className='color-red'>
              {'Please enter all available fields'}
            </p>
          ) : null
        }

        <div className='sub-form-btn-wrapper'>
          <Grid container>
            <Grid
              item
              lg={3} />
            <Grid
              item
              lg={2}>
              <button
                className='sub-add-form-btn-discard'
                onClick={handleDiscard}
              >
                <SubTooltip
                  placement='left'
                  title='Discard'
                  wrappedNode={
                    <img
                      className='sub-form-image cursor-pointer'
                      src={DiscardIcon}
                      alt='' />
                  } />
              </button>
            </Grid>
            <Grid
              item
              lg={2} />
            <Grid
              item
              lg={2}>
              {!isFormReady
                ? (
                  <SubTooltip
                    placement='right'
                    title='Submit'
                    wrappedNode={
                      <img
                        style={{
                          // @ts-ignore
                          opacity: '0.25',
                          cursor: 'not-allowed',
                        }}
                        className='sub-form-image'
                        src={SubmitIcon}
                        alt='' />
                    } />
                ) : (
                  <button
                    onClick={handleSubmit}
                    className={submitBtnClassNames}
                  >
                    <SubTooltip
                      placement='right'
                      title='Submit'
                      wrappedNode={
                        <img
                          className='sub-form-image'
                          src={SubmitIcon}
                          alt='' />
                      } />

                  </button>
                )}
            </Grid>
            <Grid
              item
              lg={3} />
          </Grid>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SubscriptionAdd;
